import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "base";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取基地列表;
    async getBaseSettingList({ commit }, payload) {
      let result = await api.get(
        `/api/FishBase?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    async addBaseSetting({ commit }, payload) {
      // 添加基地设置
      let result = await api.post("/api/FishBase", payload);
      return result;
    },
    async deleteBaseSetting({ commit }, payload) {
      // 删除基地设置
      let result = await api.delete(`/api/FishBase/${payload}`);
      return result;
    },
    async getChangeBaseSetting(cc, payload) {
      // 获取编辑基地设置数据
      let result = await api.get(`/api/FishBase/${payload}`);
      return result.data;
    },
    async changeBaseSetting(bb, payload) {
      // 改变基地设置
      let result = await api.put("/api/FishBase", payload.obj, {headers: { Sign: payload.md5 }});
      return result;
    },
    /**
     * 获取基地 KeyValue（IsPermissoin=false 为权限内列表）
     * @param {*} _ctx
     * @param {{ forQueryAll?: boolean, allOptionItem?: { key?: any, value?: string } }} [opts]
     * 查询场景 forQueryAll=true：再请求 IsPermissoin=true，仅当两次列表条数一致时在列表前插入「全部」项，否则不插入（默认选第一个基地）
     */
    async getAllBaseList(_ctx, opts) {
      const options =
        opts && typeof opts === "object" && !Array.isArray(opts) ? opts : {};
      const forQueryAll = options.forQueryAll === true;

      if (!forQueryAll) {
        let result = await api.get("/api/FishBase/KeyValue?IsPermissoin=false");
        return result.data || [];
      }

      const [resFalse, resTrue] = await Promise.all([
        api.get("/api/FishBase/KeyValue?IsPermissoin=false"),
        api.get("/api/FishBase/KeyValue?IsPermissoin=true"),
      ]);
      const listFalse = resFalse.data || [];
      const listTrue = resTrue.data || [];
      const showAllOption =
        listFalse.length > 0 && listFalse.length === listTrue.length;

      if (!showAllOption) {
        return [...listFalse];
      }

      const allOptionItem =
        options.allOptionItem && typeof options.allOptionItem === "object"
          ? { key: "", value: "全部", ...options.allOptionItem }
          : { key: "", value: "全部" };
      return [allOptionItem, ...listFalse];
    },
    //获取基地;(默认全部)--分配角色专用
    async getAllBaseLists() {
      let result = await api.get("/api/FishBase/KeyValue?IsPermissoin=true");
      return result.data;
    },
    //获取基地;(不含全部默认值)---添加页面
    async getBaseList() {
      let result = await api.get("/api/FishBase/KeyValue?");
      return result.data;
    }
  }
});

export default moduleName;
